export const LOAD_COUPONS_REQUEST = 'LOAD_COUPONS_REQUEST';
export const LOAD_COUPONS_SUCCESS = 'LOAD_COUPONS_SUCCESS';
export const LOAD_COUPONS_FAILURE = 'LOAD_COUPONS_FAILURE';
export const LOAD_COUPONS_CLEAR = 'LOAD_COUPONS_CLEAR';
